<script setup lang="ts">
import { ref } from 'vue';
import {
  Badge,
  Popover,
  PopoverContent,
  PopoverTrigger,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@manta/ui-kit';
import { Info } from 'lucide-vue-next';
import { useI18n } from 'vue-i18n';
import mantaLogo from '@/assets/manta-logo-white.svg';

const { toggleSidebar } = useSidebar();
const { t } = useI18n();

const organizationName =
  (import.meta.env.VITE_ORGANIZATION_NAME as string) || 'Manta';

const betaOpen = ref(false);
</script>

<template>
  <SidebarMenu>
    <SidebarMenuItem>
      <SidebarMenuButton
        size="lg"
        class="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
        @click="toggleSidebar"
      >
        <div
          class="flex aspect-square size-8 items-center justify-center rounded-lg bg-primary text-primary-foreground"
        >
          <img :src="mantaLogo" :alt="organizationName" class="size-4" />
        </div>
        <div class="grid flex-1 text-left leading-tight">
          <span class="truncate font-semibold">{{ organizationName }}</span>
          <span class="flex items-center gap-1.5 text-xs text-muted-foreground">
            Scribe
            <Popover v-model:open="betaOpen">
              <PopoverTrigger as-child>
                <Badge
                  variant="purple"
                  class="cursor-pointer gap-0.5 px-1.5 py-0 text-[10px] font-medium leading-tight"
                  @click.stop
                  @mouseenter="betaOpen = true"
                  @mouseleave="betaOpen = false"
                >
                  {{ t('nav.beta') }}
                  <Info class="size-2.5" />
                </Badge>
              </PopoverTrigger>
              <PopoverContent
                side="right"
                align="start"
                class="w-64 text-xs leading-relaxed text-muted-foreground"
                @mouseenter="betaOpen = true"
                @mouseleave="betaOpen = false"
              >
                {{ t('nav.betaInfo') }}
              </PopoverContent>
            </Popover>
          </span>
        </div>
      </SidebarMenuButton>
    </SidebarMenuItem>
  </SidebarMenu>
</template>
